<!-- 单笔业务合同列表 -->
<template>
  <div class="repo-notice-list">
    <h2 class="repo-notice-list__title">业务合同列表</h2>
    <div class="repo-notice-list__content">
      <el-form ref="form" class="repo-notice-list__search" :inline="true" :model="search" label-width="90px">
        <el-form-item label="合同编号">
          <el-input v-model="search.contractNo"></el-input>
        </el-form-item>
        <el-form-item label="合同名称">
          <el-input v-model="search.contractName"></el-input>
        </el-form-item>
        <el-form-item label="合同状态">
          <el-select v-model="search.contractState" placeholder="请选择">
            <el-option v-for="item in contractStateList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="search-btn" @click="searchList">查询</el-button>
        </el-form-item>
      </el-form>

      <!--列表数据-->
      <el-table :data="projectContractList" style="width: 100%;overflow: hidde" align="center" class="repo-notice-list__table">
        <el-table-column prop="contractNo" show-overflow-tooltip label="合同编号" align="center"></el-table-column>
        <el-table-column prop="contractName" show-overflow-tooltip label="合同名称" align="center"></el-table-column>
        <el-table-column prop="contractSigned" show-overflow-tooltip label="合同状态" width="150" :formatter="formatState" align="center">
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="showContract(scope.row.contractId,scope.row.contractSigned,scope.row.contractName)" class="btn operation">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="contractDiv">
        <el-dialog class="contract dialog" top="5%" title="电子合同" :visible.sync="showAgreementDialog">
          <div class="contract__dialog-body agreement_contract">
            <iframe style="max-width:100%;width:98%;height:90%" :src="'./static/pdf/web/viewer.html?file=' + readContractPdf"></iframe>
          </div>
          <div slot="footer" class="dialog__footer">
            <el-button v-if="signBtn.isShow" class="dialog__footer__confirm-btn sign_btn" :disabled="signBtn.state" @click="signConstract" style="margin-right:30px;">
              {{signBtn.text}}
            </el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import * as types from '@/vuex/types/type';
import api from '@/api/personalCenter/projectContract.js';
import pdf from 'vue-pdf';
export default {
  components: { pdf },
  props: ['singleCount'],
  name: 'LoanContractList',
  data() {
    return {
      search: {
        contractName: '',
        contractNo: '',
        contractType: '',
        contractState: '',
      },
      contractId: '',
      projectContractList: [],
      contractStateList: [
        { label: "", value: "" },
        { label: "平台已签章", value: "1" },
        { label: "待签章", value: "6" },
        { label: "买方已签章", value: "3" },
        { label: "已签章", value: "2" },
      ],
      signBtn: {
        state: false,
        text: '签章',
        isShow: true
      },
      showAgreementDialog: false,
      downloadFiledPdf: '',
      readContractPdf: ''
    };
  },
  computed: {
    ...mapGetters({
      ajaxBaseUrl: types.GET_AJAX_BASE_URL
    })
  },
  methods: {
    ...mapActions({
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setFailMessage: types.SET_FAIL_MESSAGE
    }),
    getData(search) {
      api.getProjectContractList(search).then((resp) => {
        if (resp.data.code == 0) {
          this.projectContractList = resp.data.result;
        } else {
          this.projectContractList = [];
        }
      });
    },
    formatState(row, column) {
      const data = row[column.property];
      let contractState = this.contractStateList.find((item) => item.value == data);
      if(!contractState){
        return ""
      }
      return contractState['label'];
    },
    showContract(id, state, name) {
      let _this = this;
      let contractState = this.contractStateList.find((item) => item.value == state);
      this.signBtn.text = contractState.lable;
      const CUSTOMER_UN_SIGN = "6"; // 客户未签章
      api.getIfCanSign({// 校验是否可签章
        contractId: id
      }).then((resp) => {
        if (resp.data.code == 0) {
          if(state == CUSTOMER_UN_SIGN){
            this.signBtn.text = '签章';
            this.signBtn.state = false;
          }else{
            this.signBtn.text = '已签章';
            this.signBtn.state = true;
          }
        } else {
          if(state == CUSTOMER_UN_SIGN){
            _this.setSuccessMessage({
              show: true,
              content: resp.data.msg
            });
            this.signBtn.text = resp.data.msg;
            this.signBtn.state = true;
          }else{
            this.signBtn.text = '已签章';
            this.signBtn.state = true;
          }
        }
      });
      this.readContract(id,name);
      this.showAgreementDialog = true;
    },

    searchList() {
      this.getData(this.search);
    },

    readContract(id,name) {
      this.contractId = id;
      this.downloadFiledPdf = `${this.ajaxBaseUrl}/mobile/item/pdfSignatureController/blReadContractById.ht?download=true&fileType=PDF&contractId=${id}&fileName=${name}`;
      this.readContractPdf = encodeURIComponent(this.downloadFiledPdf);
    },
    signConstract() {
      const _this = this;
      this.signBtn.state = true;
      this.signBtn.text = '签章中…';
      api.signContract({
        contractId: this.contractId
      }).then((res) => {
        if (res.code === 0) {
          if(res.result !== '签章成功'){
            this.$msgbox({
              title: "提示",
              message: "请在打开的新页面完成签章操作",
              showClose: false,
              beforeClose: (action, instance, done) => {
                if (action === 'confirm') {
                   this.getData(this.search);//刷新数据
                   this.showAgreementDialog = false;
                   done();
                } else {
                  done();
                }
              }
            });
            window.open(res.result);
	          this.signBtn.state = true;
	          this.getData(this.search);
          }else{
            this.readContract(this.contractId);
            _this.setSuccessMessage({
              show: true,
              content: res.result
            });
            this.signBtn.text = '已签章';
            this.signBtn.state = true;
            this.getData(this.search);
            this.$emit('testClick', this.singleCount-1);
          }
        } else {
          _this.setFailMessage({
            show: true,
            content: res.result
          });
          this.signBtn.text = '签章';
          this.signBtn.state = false;
        }
      }).catch((error) => {

      });
    },
  },
  mounted () {
    this.getData(this.search);
  }
};
</script>


<style>
.repo-notice-list__title {
  font-size: 22px;
  font-weight: bolder;
  height: 60px;
  line-height: 60px;
  margin-left: 20px;
}
.repo-notice-list__content {
  box-sizing: border-box;
  background-color: #fff;
  width: 970px;
  margin-left: 20px;
  padding: 30px 22px 50px 18px;
}
.repo-notice-list__table .btn {
  width: 42px;
  height: 21px;
  padding: 1px;
}

.repo-notice-list__pagination {
  text-align: center;
  margin-top: 20px;
}
.repo-notice-list__search {
  width: 910px;
}
.repo-notice-list__search input {
  width: 150px;
}
.repo-notice-list__search .search-btn {
  margin-left: 30px;
  width: 80px;
}
.down_agreen,
.sign_btn:hover {
  display: inline-block;
  border: 0;
  min-width: 120px;
  height: 45px;
  border-radius: 3px;
  font-size: 16px;
  color: #fff;
  line-height: 45px;
  text-align: center;
  background: #ff8b38;
}
.contractDiv .el-dialog__footer .el-button.is-disabled{
  background-color: #eee;
}
</style>




// WEBPACK FOOTER //
// blLoanContractList.vue?73daacf2